
import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import { REMINDER_CREATE, REMINDER_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import ReminderFilterModel from "@models/reminders/reminderFilterModel";
import ReminderGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/ReminderService/ReminderGetListResponse";
import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";
import PaginationRequest from "@/api/dataSource/api/Common/RequestModels/PaginationRequest";
import PaginationResponseT from "@/api/dataSource/api/Common/ResponseModels/PaginationResponseT";
import { readPaginationItems } from "@/utils/pagination";

@Component
export default class PageRemindersComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: ReminderFilterModel = new ReminderFilterModel();
  columnNames = ["#", "Заголовок", "Текст", "", ""];
  createRouteName = REMINDER_CREATE;
  editRouteName = REMINDER_EDIT;
  getDataFunc = this.getReminders.bind(this);
  removeFunc = this.$api.ReminderService.deleteAsync.bind(
    this.$api.ReminderService
  );
  async created() {}
  async getReminders(request: SearchFilterRequest) {
    const search = (request.Name || "").trim().toLowerCase();
    if (!search) {
      return this.$api.ReminderService.getListAsync(request);
    }

    const pagination = request.Pagination || new PaginationRequest();
    const response = await this.$api.ReminderService.getListAsync(
      new SearchFilterRequest({
        Pagination: new PaginationRequest({
          Skip: 0,
          Take: 10000,
        }),
        Search: [],
        Sort: request.Sort,
      })
    );
    const filteredItems = readPaginationItems<ReminderGetListResponse>(response)
      .filter((item) => {
        const title = (item.Title || "").toLowerCase();
        const text = (item.Text || "").toLowerCase();
        return title.includes(search) || text.includes(search);
      });
    const skip = pagination.Skip || 0;
    const take = pagination.Take || 10;

    return new PaginationResponseT<ReminderGetListResponse>({
      Count: filteredItems.length,
      Items: filteredItems.slice(skip, skip + take),
    });
  }
  async startDelete(item: ReminderGetListResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
